enum CategoryVariants {
	ARTICLE = 'categoryArticle'

}

interface IArticleCategoryCard {
	id: number
	slug: string
	type: string
	iconName: string
	backgroundPosition: string
	headline: string
	contact: string[]
	perex: string
	label: string
	link: {
		to: string
	}
	routerLink: {
		to: object
	}
	items: {
		headline: string
		paragraph: string
	}[]
}

export {
	IArticleCategoryCard,
	CategoryVariants
}
